export const fields = [
  {
    title: 'Text Field',
    icon: 'text',
    text: 'Text',
    fieldType: 1,
    fields: {
      fieldLabel: '',
      placeHolder: '',
      characterLimit: '',
      isMandatory: false,
    },
  },
  {
    title: 'Number Field',
    icon: 'number',
    text: 'Number',
    fieldType: 4,
    fields: {
      fieldLabel: '',
      placeHolder: '',
      characterLimit: '',
      isMandatory: false,
    },
  },
  {
    title: 'Email Field',
    icon: 'emailFormSVG',
    text: 'Email',
    fieldType: 2,
    fields: {
      fieldLabel: '',
      placeHolder: '',
      // showOTP: false,
      isMandatory: false,
    },
  },
  {
    title: 'Phone Number Field',
    icon: 'phoneNumber',
    fieldType: 6,
    text: 'Phone Number',
    fields: {
      fieldLabel: '',
      placeHolder: '',
      fieldMask: '',
      showCountryCode: true,
      showCountryFlag: false,
      isMandatory: false,
    },
  },
  {
    title: 'Date Field',
    icon: 'date',
    fieldType: 5,
    text: 'Date',
    fields: {
      fieldLabel: '',
      placeHolder: '',
      fieldMask: '',
      isMandatory: false,
    },
  },
  {
    title: 'Dropdown Field',
    icon: 'dropdown',
    fieldType: 9,
    text: 'Dropdown',
    fields: {
      fieldLabel: '',
      placeHolder: '',
      typeSelection: '',
      formsDetailOptions: [],
      isMandatory: false,
    },
  },
  {
    title: 'Attachment Field',
    icon: 'attachment',
    fieldType: 10,
    text: 'Attachment',
    fields: {
      fieldLabel: '',
      placeHolder: '',
      characterLimit: '',
      typeSelection: '',
      isMandatory: false,
    },
  },
  {
    title: 'Radio Button Field',
    icon: 'radioButton',
    fieldType: 8,
    text: 'Radio Button',
    fields: {
      fieldLabel: '',
      formsDetailOptions: [],
      isMandatory: false,
    },
  },
  {
    title: 'Checkbox Field',
    icon: 'checkbox',
    fieldType: 7,
    text: 'Checkbox',
    fields: {
      fieldLabel: '',
      placeHolder: '',
      formsDetailOptions: [],
      isMandatory: false,
    },
  },
];
